export const English: any = {
  dir: "ltr",
  lang: "العربية",
  arabicClass: "",
  mAuto: "ml-auto",
  benefits: "Benefits & Features",
  textAlign: "text-left",
  textAlignReverse: "text-right",
  FlexAlignItems: "align-items-start",
  noNotifications: "No New Notifications",
  rowReverse: "",
  menuStyle: "",
  menuCloseStyle: "",
  navFloat: "float-right",
  quickLinks: "Quick Links",
  followUs: "Follow Us",
  copyRights1: "Copyright &copy; 2021, All rights reserved |",
  terms: "Terms",
  policy: "Policy",
  logout: "Logout",
  headers: {
    email: "Email",
    password: "Password",
    close: "Close",
    sign: "SIGN",
    in: "IN",
    create: "CREATE",
    account: "ACCOUNT",
    newToShatablee: "New To Shatablee?",
    forgotPassword: "Forgot password?",
    registerNow: "Register now",
    enterAValidName: "Enter a valid name",
    firstName: "First Name",
    lastName: "Last Name",
    fullName: "Full Name",
    login: "Login",
    visitDate: "Date Of Visit",
    register: "Register",
    alreadyHaveAnAccount: "Already have an account ?",
    loginNow: "Login now",
    verify: "Verify",
    check: "Verify",
    confirmPassword: "Confirm Password",
    otp: "Code",
    resendOTP: "Resend OTP ?",
    forgot: "FORGOT",
    passwordCapital: "PASSWORD",
    resetPassword: "Reset Password",
    enterEmailMessage: "Enter the email address assiociated with your shatablee account",
    enterPhoneNumberMessage: "Enter the phone number assiociated with your shatablee account",
    successfullyRegistered: "Registration Successful",
    redirectingToLogin: "Redirecting you to login shortly",
    invalidOTP: "Invalid OTP",
    phoneNumber: "Phone Number",
    enterAValidNumber: "Enter a valid number",
    invalidCredentials: "Invalid Credentials",
    enterAValidEmail: "Enter a valid email",
    enterNewPasswordMessage: "Enter your new password below",
    passwordsDoNotMatch: "Passwords do not match !",
    otpSentMessage: "A 4 digit code has been sent to the phone number associated with your Shatablee account",
    emailOrNumberAlreadyInUse: "Email or phone number already in use",
    new: "NEW",
    displayInformation: "DISPLAY INFORMATION",
    displayName: "Display Name",
    title: "Title",
    secondaryContact: "Secondary Contact",
    unit: "Unit",
    company: "Company",
    dateOfBirth: "Date Of Birth",
    youCantChangeYourEmail: "you can't change your login email",
    youCantChangeYourPhone: "you can't change your phone number",
    changePassword: "Change Password",
    cancel: "Cancel",
    save: "Save",
    profileSuccessMessage: "Profile information updated successfully !",
    profileErrorMessage: "Failed to update profile information, Please try again !",

    loanApprovalInProgress: "  Loan Approval 'In Progress'",
    orderPendingApproval: " Order Approval 'In Progress'",
    orderRejected: " Your order has been rejected ",
    orderApproved: " Your order has been approved ",
    loanFormSubmitted: "Loan Form 'Submitted'",
    yourLoanWithAmount: "Your loan of amount ",
    isUnderReview: "is under view",
    wasApprovedWithTheAmount: " was approved with the amount of ",
    yourLoanHasBeenRejected: "Your Loan has been rejected",
    completed: "Completed",
    loanInUnderReview: "Loan is under 'Review'",
    loanApproved: "Loan 'Approved'",
    loanRejected: "Loan 'Rejected'"



  },
  invalid: {
    invalidEmail: "Invalid e-mail ",
    requiredEmail: "E-mail required ",
    requiredUserName: "Username required",
    requiredPassword: "Password required",
    InvalidPassword: "Invalid password",
    invalidLogin: "Enter valid email and password",
    invalidRegister: "Error submitting request, please try again shortly.",
    loginAuthenticating: "Verifying SAP connection...",
    login_SAPFailed: "Failed to connect to SAP web services, starting SAP-Connector...",
    login_SAPConnectorFailed: "SAP Connector failed, enabling offline mode...",
    loginRedirect: "You will be redirected shortly...",
    requiredField: "Required field",
    InvalidPercentage: "Invalid Percentage",
    notSubmitted: "Not Submitted",
    InvalidName: "Invalid Name",
    invalidPhoneNumber: "Invalid phone number",
    InvalidDescriptionLength: "Invalid length , Description has to be less than 200 characters long",
    InvalidCodeLength: "Invalid Code lenght, Code has to be 5 characters long",
    InvalidInputArabic: "Only arabic letters are allowed",
    InvalidInputEnglish: "Only english letters are allowed",
    InvalidAbbreviationLength: "Abbreviation has to be 10 characters or less"
  },


  showroom: {
    location1: 'NORTH TESEEN',
    location2: 'MARKERS MARK MALL - 2ND FLOOR',
    headerDetails: 'Our hosts are on hand to give a full-tour and walk-around of all of your options – or of course, we can leave you to look around yourselves. We have a no-pressure sales culture here. This means your experience at the showroom will be an enjoyable and informative one.',

  }
}
